export enum ZendeskTokenContext {
  Messaging = "Messaging",
  HelpCenter = "HelpCenter",
}
